import theme from '../../../theme'
import { StyleSheet } from 'react-native'
const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 10,
    },
    redimesModule: {
        flex: 1,
        backgroundColor: 'white',
    },
    tabBar: {
        backgroundColor: 'white',
    },
    tabLabel: {
        color: theme.colors.darkGray,
        fontSize: 14,
        fontWeight: 'bold',
    },
    tabActive: {},
    tabIndicator: {
        backgroundColor: theme.colors.colorPrimary,
    },
    tab: {},
})

export default styles
